import React from 'react';

export default class ArticleImage extends React.Component {

  render() {
    return <div>
      <p>{this.props.article.description}</p>
      <p dangerouslySetInnerHTML={{__html: this.props.article.content}}></p>
    </div>
  }
}
